export const Breakpoints = {
  mdDown: "(max-width: 991px)",
  tablet: "(max-width: 991px) and (min-width: 768px)",
  smDown: "(max-width: 767px)",
  xsDown: "(max-width: 575px)",
  lgUp: "(min-width: 992px)"
};
